import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ChevronDoubleLeftIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.92813 4.28333L12.6615 8.01667L8.92813 11.75M3.32813 4.28333L7.06146 8.01667L3.32812 11.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
